var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from "react";
import { useContext, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Typography } from "@material-ui/core";
import * as quizAnswerActions from "../../state/quizAnswer/actions";
import { initialize } from "../../state/actions";
import { updateQuizState } from "../../state/user/actions";
import Checkbox from "../CheckboxOption";
import Feedback from "../Feedback";
import MultipleChoice from "../MultipleChoice";
import ResearchAgreement from "../ResearchAgreement";
import Scale from "../Scale";
import Open from "../Open";
import Essay from "../Essay";
import ClickableMultipleChoice from "../ClickableMultipleChoice";
import MultipleChoiceDropdown from "../MultipleChoiceDropdown";
import StageVisualizer from "../PeerReviews/StageVisualizer";
import PeerReviews from "../PeerReviews";
import Unsupported from "../Unsupported";
import ResultInformation from "./ResultInformation";
import { useTypedSelector } from "../../state/store";
import Deadline from "./Deadline";
import LoadingQuiz from "./LoadingQuiz";
import TopInfoBar from "./TopInfoBar";
import SubmitButton from "./SubmitButton";
import LoginPrompt from "./LoginPrompt";
import MarkdownText from "../MarkdownText";
import SimpleErrorBoundary from "./SimpleErrorBoundary";
import Notification from "../Notification";
import { BoldTypographyMedium } from "../styleComponents";
import ThemeProviderContext from "../../contexes/themeProviderContext";
import { CourseStatusProviderContext } from "../../contexes/courseStatusProviderContext";
import { requestReviews } from "../../state/receivedReviews/actions";
var componentsByTypeNames = function componentsByTypeNames(typeName) {
  var mapTypeToComponent = {
    essay: Essay,
    "multiple-choice": MultipleChoice,
    scale: Scale,
    checkbox: Checkbox,
    open: Open,
    "research-agreement": ResearchAgreement,
    feedback: Feedback,
    "custom-frontend-accept-data": Unsupported,
    "multiple-choice-dropdown": MultipleChoiceDropdown,
    "clickable-multiple-choice": ClickableMultipleChoice
  };
  return mapTypeToComponent[typeName];
};
var QuizItemContainerDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-bottom: 2px;\n"], ["\n  padding-bottom: 2px;\n"])));
var ItemWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  /* border-radius: 10px; */\n  /* padding: 1rem 2rem 1rem 1rem; */\n  padding: 0.5rem 1.5rem;\n"], ["\n  background-color: ", ";\n  /* border-radius: 10px; */\n  /* padding: 1rem 2rem 1rem 1rem; */\n  padding: 0.5rem 1.5rem;\n"])), function (_a) {
  var rowNumber = _a.rowNumber;
  return rowNumber % 2 === 0 ? "inherit" : "#EFF4F7";
});
var QuizContent = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 1.5rem;\n  padding: 1rem;\n  ", "\n"], ["\n  margin-top: 1.5rem;\n  padding: 1rem;\n  ", "\n"])), function (_a) {
  var disabled = _a.disabled;
  return disabled && "\n        opacity: 0.6;\n        cursor: default;\n      ";
});
var UpperContent = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 0 1rem;\n  ", "\n"], ["\n  padding: 0 1rem;\n  ", "\n"])), function (_a) {
  var providedStyles = _a.providedStyles;
  return providedStyles;
});
var LowerContent = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-bottom: 1rem;\n  padding: 0.5rem 1.5rem;\n"], ["\n  margin-bottom: 1rem;\n  padding: 0.5rem 1.5rem;\n"])));
var MessageGroup = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var providedStyles = _a.providedStyles;
  return providedStyles;
});
var SubmitGroup = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  > :last-child {\n    /* margin-left: 1rem; */\n  }\n  ", "\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  > :last-child {\n    /* margin-left: 1rem; */\n  }\n  ", "\n"])), function (_a) {
  var providedStyles = _a.providedStyles;
  return providedStyles;
});
var OuterDiv = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ul {\n    padding-inline-start: 30px;\n  }\n  ", "\n"], ["\n  ul {\n    padding-inline-start: 30px;\n  }\n  ", "\n"])), function (_a) {
  var providedStyles = _a.providedStyles;
  return providedStyles;
});
var QuizBody = styled(MarkdownText)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var providedStyles = _a.providedStyles;
  return providedStyles;
});
var SubmitMessage = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  border-left: 6px solid #047500;\n  padding: 0.25rem 0 0 1rem;\n  margin 0 0 3rem 0;\n  p {\n    margin: 1rem 0px !important;\n  }\n  ", "\n"], ["\n  border-left: 6px solid #047500;\n  padding: 0.25rem 0 0 1rem;\n  margin 0 0 3rem 0;\n  p {\n    margin: 1rem 0px !important;\n  }\n  ", "\n"])), function (_a) {
  var providedStyles = _a.providedStyles;
  return providedStyles;
});
var ErrorMessage = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  display: flex;\n  width: auto;\n  padding: 4rem;\n  p {\n    font-size: 2rem;\n    margin: auto;\n  }\n"], ["\n  display: flex;\n  width: auto;\n  padding: 4rem;\n  p {\n    font-size: 2rem;\n    margin: auto;\n  }\n"])));
var FuncQuizImpl = function FuncQuizImpl(_a) {
  var _b;
  var id = _a.id,
    languageId = _a.languageId,
    accessToken = _a.accessToken,
    backendAddress = _a.backendAddress,
    customContent = _a.customContent,
    fullInfoWithoutLogin = _a.fullInfoWithoutLogin,
    _c = _a.showZeroPointsInfo,
    showZeroPointsInfo = _c === void 0 ? false : _c,
    children = _a.children,
    alternativeQuizLabel = _a.alternativeQuizLabel;
  var ref = useRef(null);
  var themeProvider = useContext(ThemeProviderContext);
  var courseStatusProvider = useContext(CourseStatusProviderContext);
  var submitLocked = useTypedSelector(function (state) {
    return state.quizAnswer.submitLocked;
  });
  var pastDeadline = useTypedSelector(function (state) {
    return state.quizAnswer.pastDeadline;
  });
  var messageState = useTypedSelector(function (state) {
    return state.message;
  });
  var quizAnswer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });
  var languageInfo = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var storeAccessToken = useTypedSelector(function (state) {
    return state.user.accessToken;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });
  var showPoints = useTypedSelector(function (state) {
    return state.customization.showPointsInfo;
  });
  var activeStep = useTypedSelector(function (state) {
    return state.peerReviews.activeStep;
  });
  var dispatch = useDispatch();
  var fatal = messageState.fatal;
  var error = messageState.error;
  useEffect(function () {
    dispatch(initialize(id, languageId, accessToken, backendAddress, fullInfoWithoutLogin, showZeroPointsInfo));
  }, [id, languageId, accessToken, backendAddress]);
  useEffect(function () {
    if (accessToken) {
      dispatch(quizAnswerActions.setQuizDisabled(false));
    }
  });
  if (fatal) {
    console.log("quiz");
    courseStatusProvider.notifyError && courseStatusProvider.notifyError(messageState.message);
    return React.createElement(ErrorMessage, null, React.createElement("p", null, messageState.message));
  }
  if (error) {
    courseStatusProvider.notifyError && courseStatusProvider.notifyError(messageState.message);
  }
  var CustomLogin = customContent && customContent.Login;
  if (!accessToken && !fullInfoWithoutLogin) {
    return React.createElement("div", null, React.createElement(TopInfoBar, {
      staticBars: true
    }), React.createElement(LoginPrompt, {
      content: CustomLogin
    }));
  }
  var loggedInButNotSetInStore = accessToken && !storeAccessToken;
  if (loggedInButNotSetInStore || !quiz) {
    return React.createElement(LoadingQuiz, {
      content: customContent,
      accessToken: accessToken
    });
  }
  if (!languageInfo) {
    return React.createElement("div", null, "language info not set");
  }
  if (courseStatusProvider.updateQuiz && courseStatusProvider.updateQuiz[quiz.id]) {
    dispatch(updateQuizState());
    dispatch(requestReviews());
    courseStatusProvider.quizUpdated && courseStatusProvider.quizUpdated(quiz.id);
  }
  var generalLabels = languageInfo.general;
  var quizItemComponents = function quizItemComponents(quiz, languageId) {
    var StyledWrapper = themeProvider.itemWrapper || ItemWrapper;
    return React.createElement(React.Fragment, null, quiz.items.sort(function (i1, i2) {
      return i1.order - i2.order;
    }).map(function (item, idx) {
      var ItemComponent = componentsByTypeNames(item.type);
      return React.createElement(StyledWrapper, {
        rowNumber: idx,
        key: item.id
      }, React.createElement(ItemComponent, {
        item: item
      }));
    }));
  };
  var triesRemaining = quiz.tries;
  var stillSubmittable = true;
  if (quiz.triesLimited) {
    var triesUsed = 0;
    if (userQuizState) {
      triesUsed = userQuizState.tries;
    }
    triesRemaining -= triesUsed;
    if (triesRemaining <= 0) {
      stillSubmittable = false;
    }
  }
  var locked = false;
  if (userQuizState) {
    locked = userQuizState.status === "locked";
  }
  if (locked || quizDisabled) {
    stillSubmittable = false;
  }
  var containsPeerReviews = ((_b = quiz.peerReviewCollections) === null || _b === void 0 ? void 0 : _b.length) > 0;
  var answerStatus = quizAnswer.status ? quizAnswer.status : null;
  var shouldShowPeerReviews = userQuizState ? userQuizState.status === "locked" ? answerStatus === "rejected" || answerStatus === "spam" ? false : true : false : false;
  var submitMessage = quiz.submitMessage;
  var exerciseFinishedMessage = activeStep === 4 ? languageInfo.peerReviews.answerConfirmed : activeStep === 3 ? answerStatus === "submitted" || answerStatus === "enough-received-but-not-given" ? languageInfo.peerReviews.manualReview : answerStatus === "rejected" ? languageInfo.peerReviews.answerRejected : answerStatus === "spam" ? languageInfo.peerReviews.answerFlaggedAsSpam : null : null;
  var showPointsPolicyLabel = !quiz.awardPointsEvenIfWrong && quiz.items.length > 1 && showPoints && quiz.items.some(function (qi) {
    return qi.type !== "checkbox" && qi.type !== "scale" && qi.type !== "feedback" && qi.type !== "research-agreement";
  });
  var QuizContentWrapper = themeProvider.quizContent || QuizContent;
  var LowerContentWrapper = themeProvider.lowerContent || LowerContent;
  var wrongLocale = !!(customContent && customContent.WrongLocale);
  return React.createElement(OuterDiv, {
    providedStyles: themeProvider.mainDivStyles,
    "aria-label": quiz.title,
    role: "form"
  }, React.createElement(TopInfoBar, {
    alternativeQuizLabel: alternativeQuizLabel
  }), React.createElement("div", {
    ref: ref
  }), React.createElement(QuizContentWrapper, {
    disabled: quizDisabled || wrongLocale
  }, React.createElement(UpperContent, {
    providedStyles: themeProvider.upperContentStyles
  }, React.createElement(Deadline, {
    deadline: quiz.deadline
  }), containsPeerReviews && React.createElement(StageVisualizer, null), React.createElement(QuizBody, {
    providedStyles: themeProvider.quizBodyStyles
  }, quiz.body), children), React.createElement(QuizItemContainerDiv, null, quizItemComponents(quiz, languageId)), React.createElement(LowerContentWrapper, {
    nItems: quiz.items.length
  }, !stillSubmittable && !quizDisabled ? React.createElement(MessageGroup, {
    providedStyles: themeProvider.messageGroupStyles
  }, submitMessage && React.createElement(React.Fragment, null, React.createElement(SubmitMessage, {
    providedStyles: themeProvider.submitMessageDivStyles
  }, React.createElement(Typography, null, languageInfo.essay.exampleAnswerLabel), React.createElement("div", null, React.createElement(MarkdownText, null, submitMessage)))), containsPeerReviews && exerciseFinishedMessage && React.createElement(BoldTypographyMedium, null, exerciseFinishedMessage), containsPeerReviews && shouldShowPeerReviews && React.createElement(PeerReviews, null), React.createElement(ResultInformation, {
    quiz: quiz,
    quizAnswer: quizAnswer,
    generalLabels: generalLabels
  })) : React.createElement(React.Fragment, null, React.createElement(SubmitGroup, {
    providedStyles: themeProvider.submitGroupStyles
  }, React.createElement("div", null), React.createElement("div", {
    onClick: function onClick(e) {
      if ((submitLocked || pastDeadline) && !quizDisabled) {
        dispatch(quizAnswerActions.noticeDisabledSubmitAttempt());
      }
    }
  }, React.createElement(SubmitButton, null)), !quizDisabled && React.createElement("div", null, pastDeadline ? React.createElement(Typography, null, generalLabels.pastDeadline) : React.createElement(React.Fragment, null, React.createElement(Typography, {
    style: {
      color: "rgba(0,0,0,0.6)",
      fontSize: "0.9rem",
      fontWeight: "normal",
      fontFamily: "Poppins"
    }
  }, quiz.triesLimited ? generalLabels.triesRemainingLabel + ": " + triesRemaining : generalLabels.triesNotLimitedLabel), showPointsPolicyLabel && React.createElement(Typography, null, generalLabels.pointsGrantingPolicyInformer(quiz.grantPointsPolicy))))))), React.createElement(Notification, {
    scrollRef: ref
  })), customContent && customContent.WrongLocale, quizDisabled && React.createElement(LoginPrompt, {
    content: customContent && customContent.Login,
    fullQuizInfoShown: true
  }));
};
export default (function (props) {
  return React.createElement(SimpleErrorBoundary, null, React.createElement(FuncQuizImpl, __assign({}, props)));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;